export default __webpack_public_path__ + "static/media/time-disabled-ico.ae28189f.svg";